export const UPDATE_MAKER_CHECKER_LIST_FILTERS =
  'UPDATE_MAKER_CHECKER_LIST_FILTERS';
export const FETCH_MAKER_CHECKER_LIST = 'FETCH_MAKER_CHECKER_LIST';
export const FETCH_MAKER_CHECKER_LIST_SUCCESS =
  'FETCH_MAKER_CHECKER_LIST_SUCCESS';
export const FETCH_MAKER_CHECKER_LIST_FAIL = 'FETCH_MAKER_CHECKER_LIST_FAIL';
export const CHANGE_MAKER_CHECKER_LIST_PAGE = 'CHANGE_MAKER_CHECKER_LIST_PAGE';
export const CHANGE_MAKER_CHECKER_LIST_PAGE_SIZE =
  'CHANGE_MAKER_CHECKER_LIST_PAGE_SIZE';
export const RELOAD_MAKER_CHECKER = 'RELOAD_MAKER_CHECKER';

export const fetchMakerCheckerList = ({ filters, currentPage, pageSize }) => ({
  type: FETCH_MAKER_CHECKER_LIST,
  payload: { filters, currentPage, pageSize }
});

export const fetchMakerCheckerListSuccess = ({ cases, total }) => ({
  type: FETCH_MAKER_CHECKER_LIST_SUCCESS,
  payload: { cases, total }
});

export const fetchMakerCheckerListFail = () => ({
  type: FETCH_MAKER_CHECKER_LIST_FAIL
});

export const changeMakerCheckerListPage = (currentPage) => ({
  type: CHANGE_MAKER_CHECKER_LIST_PAGE,
  payload: currentPage
});

export const changeMakerCheckerListPageSize = (pageSize) => ({
  type: CHANGE_MAKER_CHECKER_LIST_PAGE_SIZE,
  payload: pageSize
});

export const reloadMakerChecker = () => ({
  type: RELOAD_MAKER_CHECKER
});

export const updateMakerCheckerListFilters = (filters) => ({
  type: UPDATE_MAKER_CHECKER_LIST_FILTERS,
  payload: filters
});
